import React from 'react';
import Button from "s2s-button";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colorGrid } from 's2s-themes';
import { getIntlText } from '../../js/utilities';

const CardDetailsContainer = styled.div`
  align-items: flex-start;
  background-color: #182661;
  display: flex;
  flex: 2;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 16px;
  padding-top: 16px;
  position: relative;
  min-height: 128px;
  max-height: 128px;
`;

const NameArea = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;

const EditButton = styled(Button)`
  background-color: transparent;
  display: flex;
  height : 32px;
  justify-content : center;
  padding : 0px;
  position: absolute;
  left: 16px;
  top: 16px;
  width : 32px;

  :hover {
    background-color: ${colorGrid.gray9};
  }
`;

const DeleteButton = styled(Button)`
  background-color: transparent;
  display : flex;
  height : 32px;
  :hover {
     background-color: ${colorGrid.gray9};
  }
  justify-content : center;
  padding : 0px;
  position: absolute;
  right: 16px;
  top: 16px;
  width : 32px;
`;

const NameCompanyArea = styled.div`
  align-items: center;
  flex-direction: column;
  text-align : center;
  max-width: 60%;
  padding-bottom: 40px;
  padding-top: 40px;
`;

const EntityName = styled.div`
  color: ${colorGrid.gray0};
  flex: 5;
  font-family: Poppins;
  font-size: 24px;
  font-weight: 600;
  max-width: 300px;
  letter-spacing: 0.18px;
  overflow: hidden;
  overflow-wrap: break-word;
  text-align: center;
  text-overflow: visible;
  white-space: pre-wrap;
`;

const CompanyName = styled.div`
  color: ${colorGrid.gray0};
  display: contents;
  flex: 5;
  font-family: Poppins;
  font-size: 16px;
  max-width: 300px;
  overflow: hidden;
  overflow-wrap: break-word;
  text-align: center;
  text-overflow: visible;
  white-space: pre-wrap;
`;

const CardDetails = (props) => {
  const getEntityName = (entity) => {
    let entityName;

    if (entity && typeof entity.name !== "undefined" && typeof entity.name.first !== "undefined" && typeof entity.name.last !== "undefined") {
      entityName = `${entity.name.first} ${entity.name.last}`;
    } else {
      if (entity.name !== undefined && entity.name.last) {
        entityName = entity.name.last;
      }
      if (entity.name !== undefined && entity.name.first) {
        entityName = entity.name.first;
      }
    }

    return entityName;
  };
  const getEntityCompanyName = (entity) => {
    let entityCompanyName;

    if (entity && typeof entity.work !== "undefined" && typeof entity.work.company !== "undefined") {
      entityCompanyName = `${entity.work.company}`;
    }

    return entityCompanyName;
  };

  return (
    <CardDetailsContainer className="cardDetails">
      <NameArea className="nameArea">
        <EditButton
          ariaLabel={getIntlText(props.intl, 'ARIA-CARD-DETAILS-EDIT', 'Edit')}
          className="editBtn"
          buttonType="secondary"
          buttonSize="small"
          svgFill={colorGrid.gray0}
          svgType="MdEdit"
          cbClick={props.cbEdit}
        />
        <NameCompanyArea className="nameCompanyArea">
          <EntityName className="entityName">
            {getEntityName(props.entityDetails)}
          </EntityName>
          <CompanyName className="entityCompanyName">
            {getEntityCompanyName(props.entityDetails)}
          </CompanyName>
        </NameCompanyArea>
        <DeleteButton
          ariaLabel={getIntlText(props.intl, 'ARIA-CARD-DETAILS-DELETE', 'Delete')}
          className="deleteButton"
          buttonType="secondary"
          buttonSize="small"
          svgFill={colorGrid.gray0}
          svgType="MdDelete"
          cbClick={props.cbDelete}
        />
      </NameArea>
    </CardDetailsContainer>
  );
};

CardDetails.propTypes = {
  cbDelete: PropTypes.func,
  cbEdit: PropTypes.func,
  entityDetails: PropTypes.shape({
    name: PropTypes.shape({
      first: PropTypes.string,
      middle: PropTypes.string,
      last: PropTypes.string,
    }),
    emails: PropTypes.array, // email
    phone: PropTypes.array
  }), // userID
  intl : PropTypes.string
};

CardDetails.defaultProps = {
  cbDelete: () => { console.log('cbDelete is not defined in details.js'); },
  cbEdit: () => { console.log('cbEdit is not defined in details.js'); },
  entityDetails: {
    name: {
      first: '',
      last: ''
    },
    work: {
      company: ''
    }
  }
};

export default CardDetails;
